import Lottie from 'lottie-react';
import AISuggestedProcess from '../../../assets/AISuggestedProcess.json';

type AIProcessingLoaderProps = {
  message: string;
};

export const AIProcessingLoader = ({ message }: AIProcessingLoaderProps) => {
  return (
    <div className="h-full flex flex-col justify-center items-center">
      <Lottie animationData={AISuggestedProcess} loop={true} />
      <p className="text-sm text-purple-800 font-medium">{message}</p>
    </div>
  );
};
